import React from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Institutions = () => {
  const partners = [
    { src: "/assets/img/partner/1.webp", width: 76, height: 80 },
    { src: "/assets/img/partner/10.webp", width: 203, height: 80 },
    { src: "/assets/img/partner/2.webp", width: 80, height: 80 },
    { src: "/assets/img/partner/6.webp", width: 125, height: 80 },
    { src: "/assets/img/partner/7.webp", width: 80, height: 80 },
    { src: "/assets/img/partner/11.webp", width: 100, height: 80 },
    { src: "/assets/img/partner/5.webp", width: 80, height: 80 },

    // Second row (responsive)
    { src: "/assets/img/partner/12.webp", width: 87, height: 80 },
    { src: "/assets/img/partner/3.webp", width: 180, height: 80 },
    { src: "/assets/img/partner/13.webp", width: 87, height: 80 },
    { src: "/assets/img/partner/14.webp", width: 180, height: 80 },
    { src: "/assets/img/partner/15.webp", width: 80, height: 80 },
    { src: "/assets/img/partner/16.webp", width: 87, height: 80 },
    { src: "/assets/img/partner/4.webp", width: 113, height: 80 },
  ];

  // Split rows
  const firstRow = partners.slice(0, 7);
  const secondRow = partners.slice(7);

  return (
    <>
      <section className="client-section mt-5">
        <div className="container">
          <h4 className="fw-medium text-center mb-4">
            Dipercaya oleh Praktisi di Berbagai Instansi!
          </h4>

          {/* Row 1 (fixed) */}
          <div className="row justify-content-center mb-4">
            {firstRow.map((item, index) => (
              <div className="col-auto mx-2 mb-3" key={index}>
                <div className="institutions-items p-1 text-center">
                  <img
                    src={item.src}
                    alt="partner"
                    width={item.width}
                    height={item.height}
                    style={{
                      width: item.width,
                      height: item.height,
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Row 2 (responsive) */}
          <div className="row justify-content-center">
            {secondRow.map((item, index) => (
              <div className="col-auto mx-2 mb-3" key={index}>
                <div className="institutions-items p-1 text-center">
                  <img
                    src={item.src}
                    alt="partner"
                    width={item.width}
                    height={item.height}
                    style={{
                      width: item.width,
                      height: item.height,
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          <h4 className="fw-medium text-center my-4 text-primary">
            Dan Masih Banyak yang Lainnya
          </h4>
        </div>
      </section>
    </>
  )
}

export default Institutions
